import { useMutation } from 'react-query';
import usePlanStore from 'store/planStore';
import { shallow } from 'zustand/shallow';
import { getOOHBudget } from '../../../../../../../../api/services/mediaPlanning/offline/oohBudget';
import { useCountriesDataStore } from '../../../../../../../../store/countriesDataStore';
import { Countries } from '../../../../../../../../shared/enums';
import useCalculateOneReach from '../../../hooks/useCalculateOneReach';
import { useError } from '../../../../../common/Errors/ErrorContext/ErrorContext';

const useEstimatedOOHBudget = (isOOHAvailable?: boolean) => {
  const {
    generalInfoState,
    countryForms,
    selectedCountry,
    selectedCountryISOCode,
    updateCalculatedOOHBudget,
  } = usePlanStore();

  const { showError } = useError();

  const countryForm = countryForms[selectedCountry!];

  const optionalIds = useCountriesDataStore(
    (state) => state[selectedCountryISOCode as Countries].optionalIds,
    shallow
  );

  const {
    mutate: calculateBudget,
    data: response,
    isLoading,
    isError,
  } = useMutation(
    async () => {
      const { offline } = countryForms[selectedCountry!];
      if (!isOOHAvailable) {
        updateCalculatedOOHBudget(selectedCountry!, {
          isRequired: false,
          data: [],
        });
        return null;
      }

      return getOOHBudget(
        countryForm?.campaignScenario,
        countryForm?.targetGroup ?? '',
        selectedCountryISOCode ?? '',
        generalInfoState.division,
        generalInfoState.brand,
        generalInfoState.category
      );
    },
    {
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
      onSuccess: async (successResponse) => {
        if (successResponse) {
          updateCalculatedOOHBudget(selectedCountry!, {
            ...successResponse.data,
            data: successResponse.data.data.map((row) => ({
              ...row,
              isIncludedInCalculations:
                optionalIds[row.format + row.variant] ?? row.isRequired,
            })),
          });
        }
      },
    }
  );

  return {
    calculateBudget,
    data: response?.data,
    isLoading,
    isError,
  };
};

export default useEstimatedOOHBudget;
